import { render, staticRenderFns } from "./CriterioDetails.vue?vue&type=template&id=2fb60be3"
import script from "./CriterioDetails.vue?vue&type=script&lang=js"
export * from "./CriterioDetails.vue?vue&type=script&lang=js"
import style0 from "./CriterioDetails.vue?vue&type=style&index=0&id=2fb60be3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports